import { FieldError, UseFormSetValue, UseFormTrigger } from 'react-hook-form'
import { DateTimePickerField } from 'utoniq-ui'

import { CreateItemProps } from '@/components/pages/ConsoleItemCreate/template/ItemCreateForm'
import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'
import { convertDatePickerValueToDate, dayjs } from '@/lib/dayjs'

type SalesDateInputCellProps = {
  values: string[]
  setValue: UseFormSetValue<CreateItemProps>
  errors: FieldError[]
  trigger: UseFormTrigger<CreateItemProps>
}
export const SalesDateInputCell: Cell<SalesDateInputCellProps> = ({
  values,
  setValue,
  errors,
  trigger,
}) => {
  const { t } = useTranslation('consoleItemCreate')
  return (
    <>
      <CellFrame sx={{ pb: 3 }}>
        <DateTimePickerField
          onChange={date => {
            setValue(
              'salesStartedAt',
              convertDatePickerValueToDate(date) as never,
              {
                shouldValidate: true,
                shouldDirty: true,
              }
            )
            trigger('salesEndedAt')
          }}
          value={values[0] ? dayjs(values[0]) : null}
          placeholder={t('datePlaceholder')}
          error={errors[0]}
          title={t('salesStartAtLabel')}
          titleProps={{ variant: 'subtitle1', color: 'text.primary' }}
          description={t('salesStartAtDesc')}
        />
        <DateTimePickerField
          onChange={date => {
            setValue(
              'salesEndedAt',
              convertDatePickerValueToDate(date) as never,
              {
                shouldValidate: true,
                shouldDirty: true,
              }
            )
          }}
          value={values[1] ? dayjs(values[1]) : null}
          placeholder={t('datePlaceholder')}
          error={errors[1]}
          title={t('salesEndAtLabel')}
          titleProps={{ variant: 'subtitle1', color: 'text.primary' }}
          description={t('salesEndAtDesc')}
        />
      </CellFrame>
    </>
  )
}
